import React, {memo} from "react";
import ScrollToTopOnMount from "../../ScrollToTopOnMount";
import TnCContent from "./TnCContent";

const Terms = memo(() => {
  return(
    <div style={{ marginTop: -65 }}>
      <ScrollToTopOnMount>
        <TnCContent />
      </ScrollToTopOnMount>
    </div>
  )
});

export default Terms;
